import { InjectionToken, Signal, signal } from '@angular/core'

/** Whether the open theme is read-only for the current user; the theme page provides it to its sections. */
export const THEME_READ_ONLY = new InjectionToken<Signal<boolean>>('THEME_READ_ONLY', {
  factory: () => signal(false).asReadonly(),
})
